/**
 * Debugging flag for Evergreen apps. This enables copious browser console
 * logging along with on-page debug tools.
 *
 * Set for current page with ?debug or tizra.setDebug(true) in browser console.
 * Set for session with ?debug=session or tizra.setDebug('session')
 * Reset with ?debug=off or tizra.setDebug(false)
 */

import {IS_TEST} from './globals'
import {parseBool} from './utils'

const QUERY_KEY = 'debug'
const LOCAL_STORAGE_KEY = 'tizraDebugEnabled'

let globalDebugEnabled: boolean | 'session'

const parseDebug = (v: unknown): boolean | 'session' | undefined =>
  v === 'session' ? v : parseBool(v)

export function setDebug(setEnabled?: unknown) {
  let enabled = parseDebug(setEnabled) ?? parseDebug(getQuery(QUERY_KEY))
  if (enabled === 'session') {
    setStorage(LOCAL_STORAGE_KEY, enabled)
  } else if (enabled === false) {
    removeStorage(LOCAL_STORAGE_KEY)
  } else if (getStorage(LOCAL_STORAGE_KEY) === 'session') {
    enabled = 'session'
  }
  globalDebugEnabled = enabled ?? globalDebugEnabled ?? IS_TEST
  return globalDebugEnabled
}

function getQuery(key: string) {
  if (typeof window !== 'undefined') {
    const value = new URL(window.location.href).searchParams.get(key)
    return value === '' ? 'true' : value // ?debug is true
  }
}

function getStorage(key: string) {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      return window.localStorage.getItem(key)
    } catch {
      // ignore browser security errors
    }
  }
}

function setStorage(key: string, val: string) {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(key, val)
    } catch {
      // ignore browser security errors
    }
  }
}

function removeStorage(key: string) {
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.removeItem(key)
    } catch {
      // ignore browser security errors
    }
  }
}

export function debugging() {
  return globalDebugEnabled
}

setDebug()
